import styled from 'styled-components';
import constants from '../common/theme/constants';

const KitErrorMessage = styled.p<{ isError: boolean }>`
  font-family: ${({ theme }) => theme.font.fontFamily};
  color: ${({ isError, theme }) => (isError ? theme.error : theme.label)};
  font-size: ${constants.fontSize.text_14}rem;
  && {
    margin: ${constants.spacing.absolute.xs}px 0 0 0;
  }
  line-height: 1;
  min-height: 1rem;
`;

export default KitErrorMessage;
